/// <amd-module name="VSS/Features/MarkdownEditor/Utils/Browser" />
export function browserSupportsInsertText(): boolean {
    // IE does not support it and correctly reports that it does not support it.
    // firefox claims to support it... but lies.
    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1220696
    return document.queryCommandSupported("insertText") && !isFirefox();
}

function isFirefox(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const mozilla = /mozilla.*rv:([\d+.]+)/i.exec(navigator.userAgent);

    return !!mozilla && userAgent.indexOf("trident") === -1;
}
